import React, { Component } from "react"
import { Link } from "gatsby"
import "./index.css"

class FooterWidgets extends Component {
  render() {
    return (
      <div className="row pb-5">
        <div className="col-lg-2 col-md-12 widget-col mt-lg-0 mt-md-4 ">
          <img
            className="img-fluid"
            src={require("../../../images/taxi-on-spot-logo.png")}
          />
        </div>

        <div className="col-lg-2 col-md-12 widget-col mt-lg-0 mt-md-4">
          <h3 className="widget-head">QUICK LINKS</h3>
          <ul className="widget-links">
            <li>
              <Link to="/">Taxistar.nl</Link>
            </li>
            <li>
              <Link to="/">About us</Link>
            </li>
            <li>
              <Link to="/"> Privacy Policy</Link>
            </li>
          </ul>
        </div>

        <div className="col-lg-3 col-md-12 widget-col mt-lg-0 mt-md-4">
          <h3 className="widget-head">OUR MISSION</h3>
          <p className="footer-our-mission">
            Here you can use rows and columns here to organize your footer
            content. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
          </p>
        </div>

        <div className="col-lg-3 col-md-12 widget-col mt-lg-0 mt-md-4">
          <h3 className="widget-head">CONTACT</h3>
          <ul className="widget-links">
            <li>
              <img
                className="img-fluid"
                src={require("../../../images/icons/placeholder.png")}
              />
              {"  "}
              New York, NY 10012, US
            </li>
            <li>
              <img
                className="img-fluid"
                src={require("../../../images/icons/comment.png")}
              />
              {"  "}
              info@taxionspot.com
            </li>
            <li>
              <img
                className="img-fluid"
                src={require("../../../images/icons/phone-call.png")}
              />
              {"  "}
              04024005999
            </li>
          </ul>
        </div>

        <div className="col-lg-2 col-md-12 widget-col mt-lg-0 mt-md-4">
          <ul className="social">
            <li>
              <a href="#">
                {" "}
                <img
                  className="img-fluid"
                  src={require("../../../images/icons/instagram-icon.png")}
                />
              </a>
            </li>
            <li>
              <a href="#">
                <img
                  className="img-fluid"
                  src={require("../../../images/icons/twitter-icon.png")}
                />
              </a>
            </li>
            <li>
              <a href="#">
                <img
                  className="img-fluid"
                  src={require("../../../images/icons/fb-icon.png")}
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default FooterWidgets
